import { render, staticRenderFns } from "./OrderAlert.vue?vue&type=template&id=980a01c0"
import script from "./OrderAlert.vue?vue&type=script&lang=js"
export * from "./OrderAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports